/**
 * Hook that combines useTranslationHelper with interpolation capability
 * @returns Object with getText and getTextWithValues functions
 */
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

export const useTranslationWithInterpolation = () => {
  const getText = useTranslationHelper();

  const getTextWithValues = (
    key: string,
    fallback: string,
    values: Record<string, string | number | undefined>
  ): string => {
    let text = getText(key, fallback);

    Object.entries(values).forEach(([placeholder, value]) => {
      if (value !== undefined && value !== null) {
        text = text.replace(
          new RegExp(`{{${placeholder}}}`, 'g'),
          String(value)
        );
      }
    });

    return text;
  };

  return {
    getText,
    getTextWithValues
  };
};
